"use strict"
import React, { Component, Suspense, lazy } from 'react';
import { Route, Routes } from 'react-router-dom';
import AppRoutes from './AppRoutes';
import './custom.css';
import { NavMenu } from './components/NavMenu'
import { Container } from 'reactstrap';
import CvMakerContext from './services/app-context';
import { lang } from './services/_lang';
import Helper from './services/Helper';

import Home from './pages/Home';
import Login from './components/Login';
import Table2 from './pages/Table2';
import { ChatGpt } from './pages/ChatGPT';

export default class App extends Component {
    static displayName = App.name;

    constructor(props) {
        super(props);
        this.state = {
            selectedTab: 0,
            tabs: [/*{ t: 'Home', c: Home }, { t: 'ChatGpt', c: ChatGpt }, { t: 'Table2', c: Table2 }*/],
            lang: lang.eng,
            //currentUser: null,
            toggleLanguage: (l) => {
                for (const [key, value] of Object.entries(lang)) {
                    if (value.ـlangName == l) {
                        this.setState({ lang: value });
                        localStorage.setItem("lang", value.ـlangName);
                        break;
                    }
                }
            },
            setCurrentUser: (obj) => {
                //this.setState({ currentUser: obj });
                localStorage.setItem("currentUser", Helper.encorypt(obj));
            },
            getCurrentUser: () => {
                //if (this.state.currentUser) return this.state.currentUser;
                let a = localStorage.getItem("currentUser");
                if (!a) return null
                let cu = Helper.decode(a);
                //this.setState({ currentUser: cu });
                return cu;
            }
            , signOut: () => {
                //this.setState({ currentUser: null });
                localStorage.removeItem("currentUser");
                localStorage.removeItem("token");
            }
        };
    }

    componentDidMount() {

        this.state.toggleLanguage(localStorage.getItem("lang"));

        var elements = document.cookie.split(';');
        if (elements.length > 1)
            for (var i = 0; i < elements.length; i++) {
                let keyval = elements[i].split('=');
                let key = keyval[0].trim();
                let val = keyval[1].trim();

                if (key === "currentUser") {

                    let val2 = val.replaceAll("%7B", "{")
                        .replaceAll("%7D", "}")
                        .replaceAll("%3A", ":")
                        .replaceAll("%22", "\"")
                        .replaceAll("%2C", ",")
                        .replaceAll("%40", "@");
                    let obj = JSON.parse(val2);
                    debugger
                    localStorage.setItem(key, Helper.encorypt(obj));
                    this.removeCookie(key);
                }
                else if (key === "token") {
                    localStorage.setItem(key, val);
                    this.removeCookie(key);
                }
                else if (key === "lang") {
                    debugger
                    this.setState({ lang: val });
                }
            }
    }

    removeCookie(key) {
        document.cookie = key + '=;expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    }

    addTab(t, c) {
        let index = this.state.tabs.findIndex(x => x.t == t);
        if (index == -1)
            this.setState({ tabs: [...this.state.tabs, { t: t, c: c }] });
        else
            this.setState({ selectedTab: index });
    }

    removeTab(i) {
        debugger
        this.setState({
            tabs: this.state.tabs.splice(i, 1)
        });
    }

    render() {
        return (
            <CvMakerContext.Provider value={this.state}>
                {/*<NavMenu />*/}
                <div tag="main" className='container-fluid px-0' >
                    {/*<ul className="d-inline-flex">*/}
                    {/*    <li onClick={() => { this.addTab('ChatGpt', ChatGpt) }}*/}
                    {/*        className={`px-4 py-2 btn btn-sm  btn-danger`} >open ChatGpt</li>*/}
                    {/*    <li onClick={() => { this.addTab('Table2', Table2) }}*/}
                    {/*        className={`px-4 py-2 btn btn-sm btn-danger`} >open Table2</li>*/}
                    {/*</ul>*/}
                    {/*<ul className="d-inline-flex">*/}
                    {/*    {this.state.tabs.map((x, i) =>*/}
                    {/*        <li onClick={() => { this.setState({ selectedTab: i }) }}*/}
                    {/*            className={`px-4 py-2 ${(i == this.state.selectedTab ? 'btn-primary' : "")} `} >*/}
                    {/*            {x.t}*/}
                    {/*            <li onClick={() => { this.removeTab(i) }}*/}
                    {/*                className={`px-4 py-2 btn btn-smbtn-danger`} >X</li>*/}
                    {/*        </li>)}*/}
                    {/*</ul>*/}
                    {/*<div >*/}
                    {/*    {this.state.tabs.map((x, i) =>*/}
                    {/*        <div className={` ${(i == this.state.selectedTab ? 'btn-block' : "d-none")} `}><x.c /> </div>)}*/}
                    {/*</div>*/}
                    <Suspense fallback={<div>Loading...</div>}>
                        <Routes>
                            {AppRoutes.map((route, index) => {
                                const { element, ...rest } = route;
                                return <Route key={index} {...rest} element={element} />;
                            })}
                        </Routes>
                    </Suspense>

                </div>
            </CvMakerContext.Provider>
        );
    }
}
